import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';
import store from '@/store';

import { conduitApi } from '../api';
import { CustomerAttributesAdmin } from '../models/customerAttributes';
import { ResponseSingle } from '../models/response';
import { ULID } from '../models/uLID';

@Module({
	namespaced: true,
	name: 'customerAttribute',
	store,
	dynamic: true
})
class CustomerAttributeModule extends VuexModule {
	attributesAdmin: CustomerAttributesAdmin = null;

	@Mutation
	setAdmin(attributes: ResponseSingle<CustomerAttributesAdmin>): void {
		this.attributesAdmin = attributes.data;
	}

	@Action({ commit: 'setAdmin', rawError: true })
	async get(id: ULID): Promise<ResponseSingle<CustomerAttributesAdmin>> {
		try {
			const response = await conduitApi.get(`/customers/${id}/attributes/admin`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async put(attributes: CustomerAttributesAdmin): Promise<void> {
		try {
			await conduitApi.put(`/attributes/admin/${attributes.id}`, JSON.stringify(attributes));
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(CustomerAttributeModule);
